import { render, staticRenderFns } from "./product-bundle-requirement-table.vue?vue&type=template&id=7d8b8e8d&"
import script from "./product-bundle-requirement-table.vue?vue&type=script&lang=js&"
export * from "./product-bundle-requirement-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports